import { Divider, Typography } from "@material-ui/core";
import styled from "styled-components";

export const GroupLabel = styled(Typography)`
  display: block;
  letter-spacing: 0.06em;
`;

export const PermissionItem = styled.div`
  padding: 4px 0 12px;
`;

export const StyledDivider = styled(Divider)`
  margin: 8px 0 16px;
`;

export const UnrestrictedPermissions = styled.span`
  color: #2e7d52;
  display: inline-flex;
  font-size: 0.875rem;
  gap: 6px;
  white-space: nowrap;

  svg {
    font-size: 1.05rem;
  }
`;
